import React from "react";
import _ from "lodash";
import math from "mathjs";
import { InputCell, NumberInputCell } from "../location-edit/LocationEditForm";
import { FlexRow } from "./GeofenceEditForm";

export class RadialForm extends React.Component {
  state = {
    radiusMiles: 1.0
  };

  componentDidUpdate(prevProps) {
    const { buffer } = this.props.data.geofence.properties;
    const prevBuffer = prevProps.data.geofence.properties.buffer;
    if (buffer === prevBuffer) {
      return;
    }
    const radiusMeters = math.unit(buffer, "m");
    const radiusMilesRaw = radiusMeters.to("mile");
    const radiusMiles = _.round(radiusMilesRaw.toNumber(), 5);
    this.setState({ radiusMiles });
  }

  render() {
    const { data, mergeData } = this.props;
    const [lng, lat] = data.geofence.geometry.coordinates;
    return (
      <FlexRow>
        <NumberInputCell
          label="Latitude"
          value={lat}
          onChange={val =>
            mergeData({
              geofence: {
                geometry: { coordinates: [lng, Number.parseFloat(val)] }
              }
            })
          }
        />
        <NumberInputCell
          label="Longitude"
          value={lng}
          onChange={val =>
            mergeData({
              geofence: {
                geometry: { coordinates: [Number.parseFloat(val), lat] }
              }
            })
          }
        />
        <InputCell
          label="Radius (mi)"
          value={this.state.radiusMiles}
          onChange={valMiles => {
            this.setState({ radiusMiles: valMiles });
            try {
              const radiusMeters = math.unit(valMiles, "mile").to("m");
              mergeData({
                geofence: { properties: { buffer: radiusMeters.toNumber() } }
              });
            } catch (err) {
              // ignore invalid number - probably temporary as user continues to edit
            }
          }}
        />
      </FlexRow>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/geofence-edit/GeofenceEditRadialForm.js